import { useRef, useCallback } from 'react';

import { ButtonWithDropdown } from '@simplywallst/ui-core';
import MoreVerticalSolid from '@simplywallst/ui-core/icons/MoreVerticalSolid';

import type { Holding } from '@/hooks/portfolio/usePortfolio';

import { useRemoveManualHolding } from '../../../hooks/useRemoveManualHolding';

interface Props {
  holdingId: Holding['id'];
  onRemove: () => void;
}

export const HoldingMoreOptions = ({ holdingId, onRemove }: Props) => {
  const { mutate } = useRemoveManualHolding();

  const { current: options } = useRef([
    {
      label: 'Delete',
      value: 'remove-holding',
    },
  ]);

  const handleSelect = useCallback(
    (value: string) => {
      if (value === 'remove-holding') {
        mutate({ id: holdingId });
        onRemove();
      }
    },
    [holdingId, mutate, onRemove]
  );

  return (
    <ButtonWithDropdown
      styleType="passive"
      data-cy-id="holding-manual-more-options"
      options={options}
      onSelect={handleSelect}
    >
      <MoreVerticalSolid aria-label="More Options" />
    </ButtonWithDropdown>
  );
};
